import { apiClient } from '$lib/api/client';
import type { Suggestion } from '$lib/types/api';

/**
 * Below this the server has nothing useful to say and every keystroke is a
 * request. Three characters is where the sidebar's selector already drew it.
 */
export const minQueryLength = 3;

/**
 * Companies whose name starts like this, for picking one by hand.
 *
 * Lifted out of the sidebar's sample selector, which called the route inline,
 * so the guided step asking the same question asks it the same way — same
 * endpoint, same minimum, same behaviour when it fails. A failed lookup is an
 * empty list rather than an error: the customer is mid-word, and a dropdown
 * that turns into a red banner because one keystroke lost its connection is
 * worse than one that shows nothing.
 */
export async function suggestCompanies(query: string): Promise<Suggestion[]> {
  if (query.trim().length < minQueryLength) return [];

  try {
    const response = await apiClient.get<Suggestion[]>('/autocomplete/suggest', { q: query });
    return response.data ?? [];
  } catch {
    return [];
  }
}
